import { createAction, props } from "@ngrx/store";
import { PaymentDto } from "../interfaces/payment_dto";
import { PaymentAddRequest } from "../interfaces/payment_add_request";
import { PaymentBalance } from "../interfaces/payment_balance";
import { SendRequest } from "../interfaces/send_request";

export const loadPayments = createAction(
    "[Payments] Get Payments",
);

export const loadPaymentsSuccess = createAction(
    "[Payments] Get Payments Success",
    props<{ payments: PaymentDto[] }>()
);

export const selectPayment = createAction(
    "[Payments] Select Payment",
    props<{ payment: PaymentDto }>()
);

export const addPayments = createAction(
    "[Payments] Add Payments",
    props<{ payments: PaymentDto[] }>()
);

export const addPayment = createAction(
    "[Payments] Add Payment",
    props<{ payment: PaymentDto }>()
);

export const addPaymentSuccess = createAction(
    "[Payments] Add Payment Success",
    props<{ payment: PaymentDto }>()
);

export const setPaymentFilter = createAction(
    "[Payments] Set Filter",
    props<{ paymentFilter: string }>()
);

export const getPaymentBalance = createAction(
    "[Payments] Get Payment Balance",
    props<{ student_id: number }>()
)

export const getPaymentBalanceSuccess = createAction(
    "[Payments] Get Payment Balance Success",
    props<{ openPayments: PaymentBalance[] }>()
)

export const clearPaymentBalance = createAction(
    "[Payments] Clear Payment Balance"
)

export const upsertPayments = createAction(
    "[Payments] Upsert Payments",
    props<{ payments: PaymentDto[] }>()
);

export const createAndSendPaymentMail = createAction(
    "[Invoices] Create And Send Mail",
    props<{ sendRequest: SendRequest, paymentAddRequest: PaymentAddRequest, file: File }>()
);

export const deletePayment = createAction(
    "[Payments] Delete Payment",
    props<{ payment_id: number }>()
);

export const deletePaymentSuccess = createAction(
    "[Payments] Delete Payment Success",
    props<{ payment: PaymentDto }>()
);